let HomepageComponent: React.ComponentType | null = null;

export const preloadHomepage = async () => {
  const mod = await import('../Homepage/Homepage');
  HomepageComponent = mod.default;
};

export const getHomepageComponent = () => HomepageComponent;